import * as React from 'react';
import { DesktopSimpleLayout } from '../../../components/SimpleLayout';
import { GalleryContainer } from '../../Gallery';
import { LoadMoreButtonContainer } from '../../LoadMoreButton';
import { FullscreenGalleryContainer } from '../../FullscreenGallery';

export const DesktopSimpleViewContainer: React.FC = () => {
  return (
    <>
      <DesktopSimpleLayout gallery={<GalleryContainer />} loadMoreButton={<LoadMoreButtonContainer />} />
      <FullscreenGalleryContainer />
    </>
  );
};
